import { KurssloeyfeData, KurssloeyfeDataVariables } from "__generated__/types";
import { LoadingLayout } from "common/components/layouts/LoadingLayout";
import { NormalContentLayout } from "common/components/layouts/NormalContentLayout";
import { NoDataError } from "common/components/NoDataError";
import { useSimpleQuery } from "common/graphql/useSimpleQuery";
import { kurssloeyfeUrlByType } from "domain/common/url-utils";
import { getFirstPublishedKurssloeyfeElement } from "domain/kurssloeyfe/utils";
import gql from "graphql-tag";
import React from "react";
import { Navigate, useParams } from "react-router";

const GET_KURSSLOEYFE = gql`
  query KurssloeyfeData($kurssloeyfeId: ID!) {
    kurssloeyfeById(id: $kurssloeyfeId) {
      id
      status
      title
      context {
        id
        title
      }
      elements {
        id
        content {
          id
          status
        }
      }
    }
  }
`;

type RouteProps = {
  kurssloeyfeId: string;
};

export const KurssloeyfePage: React.FC = () => {
  const { kurssloeyfeId } = useParams<RouteProps>();

  if (!kurssloeyfeId) {
    throw new Error("Unexpected error: Missing kurssloeyfeId");
  }

  const { data, loadingOrError } = useSimpleQuery<
    KurssloeyfeData,
    KurssloeyfeDataVariables
  >(GET_KURSSLOEYFE, {
    variables: {
      kurssloeyfeId,
    },
  });

  if (loadingOrError) {
    return <LoadingLayout>{loadingOrError}</LoadingLayout>;
  }

  if (!data || !data.kurssloeyfeById) {
    return (
      <LoadingLayout>
        <NoDataError />
      </LoadingLayout>
    );
  }

  const kurssloeyfe = data.kurssloeyfeById;

  const firstKurssloeyfeElement =
    getFirstPublishedKurssloeyfeElement(kurssloeyfe);

  return firstKurssloeyfeElement ? (
    <Navigate
      to={kurssloeyfeUrlByType(
        firstKurssloeyfeElement.content.__typename,
        firstKurssloeyfeElement.content.id,
        kurssloeyfe.id,
      )}
    />
  ) : (
    <NormalContentLayout
      title={kurssloeyfe.title}
      context={kurssloeyfe.context ?? []}
    >
      <p>Oisann – det manglet dessverre innhold i denne kurssløyfen!</p>
    </NormalContentLayout>
  );
};
